(function () {
  function initSection(section) {
    var dataEl = section.querySelector('[data-mih-vreel-data]');
    var modal = section.querySelector('[data-mih-vreel-modal]');
    var player = section.querySelector('[data-mih-vreel-player]');
    var captionEl = section.querySelector('[data-mih-vreel-caption]');
    var prevBtn = section.querySelector('[data-mih-vreel-prev]');
    var nextBtn = section.querySelector('[data-mih-vreel-next]');
    var closeBtn = section.querySelector('[data-mih-vreel-close]');
    var openers = section.querySelectorAll('[data-mih-vreel-open]');

    if (!dataEl || !modal || !player) return;

    var videos = [];
    try { videos = JSON.parse(dataEl.textContent || '[]'); } catch (e) { videos = []; }
    if (!videos.length) return;

    // Move modal to <body> so it escapes any ancestor stacking context
    // (e.g. Shopify section transforms, sticky header z-index).
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    var current = 0;

    function load(i) {
      if (i < 0 || i >= videos.length) return;
      current = i;
      var item = videos[i];
      if (item && item.src) {
        player.src = item.src;
        player.load();
        var p = player.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else {
        player.removeAttribute('src');
      }
      captionEl.textContent = (item && item.caption) || '';
      if (prevBtn) prevBtn.disabled = i === 0;
      if (nextBtn) nextBtn.disabled = i === videos.length - 1;
    }

    function open(i) {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      load(i);
    }

    function close() {
      player.pause();
      player.removeAttribute('src');
      player.load();
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-index'), 10) || 0;
        open(idx);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { if (current > 0) load(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { if (current < videos.length - 1) load(current + 1); });
    if (closeBtn) closeBtn.addEventListener('click', close);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft' && current > 0) load(current - 1);
      else if (e.key === 'ArrowRight' && current < videos.length - 1) load(current + 1);
    });

    // Touch swipe
    var touchStartX = 0;
    var touchStartY = 0;
    modal.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches[0]) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    modal.addEventListener('touchend', function (e) {
      if (!e.changedTouches || !e.changedTouches[0]) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0 && current < videos.length - 1) load(current + 1);
        else if (dx > 0 && current > 0) load(current - 1);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mih-video-reel]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section reload (Theme Editor)
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-mih-video-reel]');
    if (sec) initSection(sec);
  });
})();
